import { IFormGroup } from "../../../../components/UserProfile/Interface/IFormGroup";
import {
	Agency,
	Channels,
	OfficeLocation,
    WorkForHub,
	HubLocation,
	WorkForActivation,
} from "./FormElements";


export const ProfileGroup: IFormGroup = {
	id: "profilegroup",
	elements: [
		Agency,
		OfficeLocation,
		WorkForActivation,
		Channels,
		WorkForHub,
		HubLocation,
	],
	isVisible: true,
	title: ""
};